import { capitalizeWords } from "../capitalizeText"

export const onFormatPurchaseStatus = (status: string) => {
	const name = capitalizeWords(status);
    switch (status) {
        case 'approved':
            return { name, color: 'border-[#1389e6]', text: 'text-[#1389e6]' }
        case 'invoiced':
		case 'draft':
		case 'pending':
            return { name, color: 'border-[#00330F]', text: 'text-[#00330F]' }
        case 'match':
            return { name, color: 'border-[#008000]', text: 'text-[#008000]' }
        case 'mismatch':
		case 'rejected':
            return { name, color: 'border-[#E50000]', text: 'text-[#E50000]' }
        default:
            return { name, color: 'border-[#1389e6]', text: 'text-[#1389e6]' }
    }
}